import React, { FC } from 'react';
import {
  TimePicker as AntTimePicker,
  TimePickerProps,
  TimeRangePickerProps,
} from 'antd';
import cn from 'classnames';

import { ClockIcon } from '@revfluence/fresh-icons/regular';
import { CircleXmarkIcon } from '@revfluence/fresh-icons/solid';
import styles from './TimePicker.module.scss';

import { RangePicker } from './RangePicker';

type TTimePickerProps = TimePickerProps;

export type { TimePickerProps };

type TTimePicker = React.FC<TTimePickerProps> & {
  RangePicker: FC<TimeRangePickerProps>;
};

const defaultFormat = 'h:mm:A';

export const TimePicker: TTimePicker = ({ className, ...props }) => (
  <AntTimePicker
    className={cn(styles.TimePicker, className)}
    format={defaultFormat}
    clearIcon={<CircleXmarkIcon />}
    suffixIcon={<ClockIcon />}
    {...props}
  />
);

TimePicker.RangePicker = RangePicker;
